<script>
  export default {
    props: {
      primary: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      secondary: {
        type: Boolean,
        default: false
      },
      rounded: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<template>
  <div
    class="badge"
    :class="{
      'primary': primary,
      'small': small,
      'secondary': secondary,
      'rounded-sm': rounded
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .badge {
    @apply inline-block;
    @apply text-blue-500;
    @apply py-1;
    @apply px-2;
    @apply bg-blue-100;
    @apply font-primary;
    @apply text-sm;
    @apply font-bold;
    line-height: 12px;

    &.primary {
      @apply bg-blue-500;
      @apply text-white;
    }

    &.secondary {
      @apply text-orange-300;
      @apply bg-orange-100;
    }

    &.small {
      @apply text-xs px-1;
    }
  }
</style>
